export default "__VITE_ASSET__BP01caZf__"